<template>
  <div class="time cart-button">
    <div class="vl" @click="addToCart" v-if="!isInCart">
      <font-awesome-icon icon="shopping-bag"></font-awesome-icon>
      <p>Add <br />to Cart</p>
    </div>
    <div class="vl animated fadeIn" @click="removeFromCart" v-if="isInCart">
      <font-awesome-icon icon="shopping-bag"></font-awesome-icon>
      <p>Remove <br />from Cart</p>
    </div>
  </div>
</template>

<script>
import { cartApis } from "../../services/cartApis";
import { store } from "../../store/store";
import { mapGetters } from "vuex";

export default {
  name: "cart-button",
  data() {
    return {
      isInCart: false,
      cartData: []
    };
  },
  props: {
    courseName: String,
    courseId: String,
    price: Number,
    imageUrl: String,
    courseType: String
  },
  computed: {
    ...mapGetters("cart", ["getCart"]),
    ...mapGetters("user", ["isAuthenticated"])
  },
  mounted() {
    this.cartData = this.getCart;
    const courseInCart = this.getCart.find(course => {
      return course.course_id === this.courseId;
    });
    if (courseInCart) {
      this.isInCart = true;
    } else {
      this.isInCart = false;
    }
  },
  methods: {
    addToCart() {
      const courseData = {
        course_name: this.courseName,
        course_id: this.courseId,
        price: this.price,
        image_url: this.imageUrl,
        course_type: this.courseType
      };
      this.cartData.push(courseData);
      store.dispatch("cart/addToCart", this.cartData);
      this.isInCart = true;
      this.$bvToast.toast(`Added to Cart`, {
        title: "Cart",
        autoHideDelay: 500,
        appendToast: true
      });
      if (this.isAuthenticated) {
        cartApis.insertCart(this.cartData);
      }
    },
    removeFromCart() {
      const courseIndex = this.getCart.findIndex(course => {
        return course.course_id === this.courseId;
      });
      console.log(courseIndex);
      this.cartData.splice(courseIndex, 1);
      store.dispatch("cart/addToCart", this.cartData);
      this.isInCart = false;
      this.$bvToast.toast(`Removed from Cart`, {
        title: "Cart",
        autoHideDelay: 500,
        appendToast: true
      });
      if (this.isAuthenticated) {
        cartApis.insertCart(this.cartData);
      }
    }
  }
};
</script>

<style scoped></style>
